import React from 'react';
import { InView } from 'react-intersection-observer';

import Profile from "../images/profile.jpg";
import CSS3 from "../images/skills/CSS3.png";
import Git from "../images/skills/Git.png";
import HTML5 from "../images/skills/HTML5.png";
import JavaScript from "../images/skills/JavaScript.png";
import ReactJs from "../images/skills/React.png";
import Sass from "../images/skills/Sass.png";
import Typescript from "../images/skills/Typescript.png";
import Wordpress from "../images/skills/Wordpress.png";

import Skill from "./skill";


function About() {

    const skills =[
        {title:"javascript",icon:JavaScript,percentage:80},
        {title:"react",icon:ReactJs,percentage:85},
        {title:"html",icon:HTML5,percentage:95},
        {title:"css",icon:CSS3,percentage:95},
        {title:"git",icon:Git,percentage:80},
        {title:"sass",icon:Sass,percentage:75},
        {title:"typescript",icon:Typescript,percentage:70},
        {title:"wordpress",icon:Wordpress,percentage:50}
    ];
  return (
    <div className="about-section" id="about_section">
        <div className="section-padding">
            <div className="sec-1">
                <img src={Profile} alt="samran feli moghadam" className="profile-image" />
                <div className="profile-info">
                    Hello, I am
                    <h2 className="profile-name">Samran Feli Moghadam</h2>
                    <h3 className="profile-job">front-end web developer.</h3>
                    <a href="/resume.pdf" className="download-link" download >Download Resume</a>
                </div>
            </div>
        </div>
        <hr className="divider" />
        <div className="section-padding">
            <div className="about-3-block">
                <div>
                    <h4 className="section-title">About Me</h4>
                    <p>
                        My name is Samran and I'm a front-end developer based in Tehran. I describe myself as a passionate developer who loves coding, design and working with visual elements.
                    </p>
                    <p>
                        Aside from my job, I like to contribute in diverse projects. It helps me to learn new stuffs and grow as a developer.
                    </p>
                    <p>
                        In my free time you can find me in Hiking and mountaineering or at art drawing studios.
                    </p>
                </div>
                <div>
                    <h4 className="section-title">Educations</h4>
                    <h5 className="simple-title">Art Studies (M.A)</h5>
                    <strong>2012 - 2014</strong>
                    <p>
                        Art University of Tehran (leaving course)
                    </p>
                    <h5 className="simple-title">Mechanical Engineering (B.Eng)</h5>
                    <strong> 2005 - 2009 </strong>
                    <p>
                        Isfahan University of Technology
                    </p>
                </div>
                <div>
                    <h4 className="section-title">Experiences</h4>
                    <h5 className="simple-title">Itours (2019 - Now)</h5>
                    <p>
                    front-end developer (html, React)
                    </p>
                    <h5 className="simple-title">Dadehpardaz (2018-2019)</h5>
                    <p>
                    front-end developer (html, jquery, Liferay)
                    </p>
                    <h5 className="simple-title">Raahbar (2017-2018)</h5>
                    <p>
                    front-end developer (html, jquery)
                    </p>
                    <h5 className="simple-title">Roshan Jahan Afarin (2017)</h5>
                    <p>
                         front-end developer (html)
                    </p>
                </div>
            </div>
        </div>
        <hr className="divider" />
        <div className="section-padding text-center">
            <h4 className="section-title">Skills</h4>
            <div className="skills-holder">
                {skills.map(skill=><InView key={skill.title} triggerOnce>
                    {({ inView, ref, entry }) => (
                    <div ref={ref} className="min-h-75">{inView && <Skill icon={skill.icon} title={skill.title} percentage={skill.percentage} />}</div>                    
                    )}
                </InView>)}
            </div>
        </div>
    </div>
  );
}

export default About;